import React from 'react';
import { Switch, Route } from 'react-router-dom';
import NotFound from 'yoda-app-shell/lib/components/NotFound/NotFound';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import CartPage from './containers/Pages/Cart/CartPageLazy';
import SignInPage from './containers/Pages/SignIn/SignInPageLazy';
import ResetPasswordPage from './containers/Pages/ResetPassword/ResetPasswordPageLazy';
import GiftCard from './containers/Pages/GiftCard/GiftCardPageLazy';

export default function App() {
    return (
        <Switch>
            <Route exact path="/cart/meta" component={CartPage} />
            <Route exact path="/cart" component={CartPage} />
            <Route exact path="/cart/signin" component={SignInPage} />
            <Route exact path="/cart/resetpassword" component={ResetPasswordPage} />
            <Route exact path="/cart/giftcard" component={GiftCard} />
            <Route exact path="/cart-core-preview/cart" component={CartPage} />
            {/* when none of the above match, <NoMatch> will be rendered */}
            <Route component={NotFound} />
        </Switch>
    );
}
/* This import is to move the common js/css to the root instead of going into lazy loaded js/css */
App.Layout = Layout;
